import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import Input from 'views/ui/form_elements/input';
import DateInput from 'views/ui/form_elements/date_input';
import FormControllerProxy from 'lib/form/controller_proxy';
import Dropdown from 'views/ui/form_elements/dropdown';
import Radios from 'views/ui/form_elements/radios';
import MultiSelect from 'views/ui/form_elements/multi_select_boxes';
import { t } from 'services/translation';
import NPS from 'views/ui/nps_score';
import { capitalize } from 'lib/string_utils';
import {
  getDateMask,
  getDatePlaceholder,
} from 'ui_system/utilities/timezoneUtils';
import Waiver from './waiver';

export default createReactClass({
  displayName: 'CheckoutQuestions',

  mixins: [FormControllerProxy],

  propTypes: {
    questions: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    googleTagManagerCheckoutProgress: PropTypes.func,
  },

  getDefaultProps() {
    return {
      value: null,
      icon: <i className="af-triangle-down-2 icon icon-anyfont" />,
    };
  },

  _isAndroid() {
    return (
      window.mobileDetect && window.mobileDetect.ua.indexOf('Android') > -1
    );
  },

  getInitialState() {
    return this.initialStateFromProps();
  },

  componentDidMount() {
    const events = ['focus', 'click'];
    const multiEventListener = () => {
      this.props.googleTagManagerCheckoutProgress(4);
      events.forEach((event) => {
        this.questions.removeEventListener(event, multiEventListener, {
          capture: true,
        });
      });
    };
    events.forEach((event) => {
      this.questions.addEventListener(event, multiEventListener, {
        capture: true,
      });
    });
  },

  initialStateFromProps() {
    const checkoutQuestions = this.props.questions.map((question) => ({
      position: question.position,
      text: question.text,
      answer: question.answer,
    }));
    return { checkoutQuestions };
  },

  answerForQuestion(question) {
    return question.answer;
  },

  answersForQuestion(question) {
    return question.answer || [];
  },

  inputChanged(position, name, value, e) {
    const { onChange } = this.props;

    // waivers will save as 'f' if we don't provide the 'no'
    if (typeof value === 'boolean') {
      value = value ? 'yes' : 'no';
    }

    onChange(position, value);
  },

  optionSelected(name, value) {
    const position = /-(\d+)/.exec(name)[1];
    this.props.onChange(parseInt(position, 10), value);
  },

  errorsForQuestion(question) {
    const errors = this.props.errors.get('checkout_questions');
    return !!errors && errors[0][question.position];
  },

  renderLabels(question) {
    return (
      <>
        <label>{question.text}</label>
        {Boolean(question?.subtitle) && (
          <div className="sub-title">
            <span>{question?.subtitle}</span>
          </div>
        )}
      </>
    );
  },

  renderAsTextInput(question) {
    return (
      <div>
        {this.renderLabels(question)}
        <Input
          data-testid="text-question-input"
          value={this.answerForQuestion(question)}
          name={`answer-${question.position}`}
          errors={this.errorsForQuestion(question)}
          onChange={this.inputChanged.bind(this, question.position)}
          maxLength="5000"
        />
      </div>
    );
  },

  renderAsDateInput(question) {
    let labelText = question.text;
    if (this._isAndroid()) {
      labelText = labelText.replace('(MM/DD/YYYY)', '');
    }
    return (
      <div>
        {this.renderLabels(question)}
        <DateInput
          mask={getDateMask(question.date_format)}
          data-testid="date-question-input"
          placeholder={t(getDatePlaceholder(question.date_format))}
          style={{ letterSpacing: '2px' }}
          value={this.answerForQuestion(question)}
          pattern="[0-9]*"
          name={`answer-${question.position}`}
          errors={this.errorsForQuestion(question)}
          onChange={this.inputChanged.bind(this, question.position)}
          maxLength="150"
        />
      </div>
    );
  },

  renderAsSelectInput(question) {
    const optionMap = question.options.reduce((map, opt) => {
      map[`${opt.text} `] = `${opt.text}`;
      return map;
    }, {});
    const dropdownProps = {
      'data-testid': 'select-question-input',
      name: `answer-${question.position}`,
      errors: this.errorsForQuestion(question),
      options: optionMap,
      value: this.answerForQuestion(question),
      icon: this.props.icon,
      placeholder: capitalize(`${t('SELECT_ONE')}`),
      onChange: this.optionSelected,
      theme: 'checkout',
      subtext: question.subtext,
    };

    return (
      <div>
        {this.renderLabels(question)}
        <Dropdown {...dropdownProps} />
      </div>
    );
  },

  multiClicked(values, question, itemValue, itemPosition) {
    var newValues;
    if (values.includes(itemValue)) {
      const elementIndex = values.indexOf(itemValue);
      values[elementIndex] = null;
      newValues = values;
    } else {
      // To sort answers in order of position
      values[itemPosition] = itemValue;
      newValues = values;
    }
    this.radioClicked(question.position, newValues);
  },

  radioClicked(position, itemValue) {
    this.props.onChange(position, itemValue);
  },

  renderAsRadioInput(question) {
    return (
      <div>
        {this.renderLabels(question)}
        <Radios
          data-testid="radio-question-input"
          items={question.options}
          errors={this.errorsForQuestion(question)}
          selectedValue={this.answerForQuestion(question)}
          onClick={this.radioClicked.bind(this, question.position)}
          subtext={question.subtext}
        />
      </div>
    );
  },

  renderAsMultiInput(question) {
    const answers = this.answersForQuestion(question);
    return (
      <div>
        {this.renderLabels(question)}
        <MultiSelect
          data-testid="radio-question-input"
          items={question.options}
          errors={this.errorsForQuestion(question)}
          selectedAnswers={answers}
          onClick={this.multiClicked.bind(this, answers, question)}
          subtext={question.subtext}
        />
      </div>
    );
  },

  renderAsWaiver(question) {
    return (
      <Waiver
        data-testid="waiver-question-input"
        question={question}
        value={this.answerForQuestion(question)}
        onChange={this.inputChanged.bind(this, question.position)}
        errors={this.errorsForQuestion(question)}
      />
    );
  },

  renderAsNpsScale(question) {
    return (
      <div>
        {this.renderLabels(question)}
        <NPS
          data-testid="nps-question-input"
          items={question.options}
          errors={this.errorsForQuestion(question)}
          selectedValue={this.answerForQuestion(question)}
          onClick={this.radioClicked.bind(this, question.position)}
        />
      </div>
    );
  },

  renderQuestions() {
    return this.props.questions.map(this.renderQuestion);
  },

  renderQuestion(question, index, questions) {
    const { renderBottomBorder } = this.props;
    const { id, input_type: inputType } = question;
    let firstClass = '';
    if (index === 0) firstClass = 'first';

    // Render bottom border only if theres a following section
    let lastClass = '';
    if (!this.props.renderBottomBorder && index === questions.length - 1) {
      lastClass = 'last';
    }

    return (
      <div
        key={id}
        className={`CheckoutQuestion ${firstClass} ${lastClass}`}
        data-testid={`checkout-question-${index}`}
      >
        <div className={`row ${inputType}`}>
          {inputType === 'text' && this.renderAsTextInput(question)}
          {inputType === 'select' && this.renderAsSelectInput(question)}
          {inputType === 'date' && this.renderAsDateInput(question)}
          {inputType === 'radio' && this.renderAsRadioInput(question)}
          {inputType === 'multi' && this.renderAsMultiInput(question)}
          {inputType === 'nps' && this.renderAsNpsScale(question)}
          {inputType === 'waiver' && this.renderAsWaiver(question)}
        </div>
      </div>
    );
  },

  render() {
    return (
      <div
        className="CheckoutQuestions"
        ref={(c) => {
          this.questions = c;
        }}
      >
        {this.renderQuestions()}
      </div>
    );
  },
});
